import { useCurrentPatientIdParam } from '@/hooks';
import {
  ProtocolStatuses,
  ProtocolStatusesWithMeta,
  useProtocolStatusesQuery
} from '@/modules/protocol';
import { QueryResultLike } from '@/modules/surgicalEvent/util';

type ReturnValue<InclMeta extends boolean | undefined> = ReturnType<
  typeof useProtocolStatusesQuery
> &
  QueryResultLike<
    InclMeta extends true ? ProtocolStatusesWithMeta : ProtocolStatuses
  >;

type UseCurrentProtocolStatusesOpts<InclMeta extends boolean | undefined> = {
  includeMeta?: InclMeta;
};

export const useCurrentProtocolStatuses = <
  InclMeta extends boolean | undefined
>({
  includeMeta
}: UseCurrentProtocolStatusesOpts<InclMeta> = {}): ReturnValue<InclMeta> => {
  const patientId = useCurrentPatientIdParam() ?? '';

  return useProtocolStatusesQuery<ReturnValue<InclMeta>>(
    { patientId, includeMeta },
    {
      skip: !patientId
    }
  );
};
